import { render, staticRenderFns } from "./brakescheck.vue?vue&type=template&id=7b1cf12e&scoped=true"
import script from "./brakescheck.js?vue&type=script&lang=js&external"
export * from "./brakescheck.js?vue&type=script&lang=js&external"
import style0 from "./brakescheck.vue?vue&type=style&index=0&id=7b1cf12e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1cf12e",
  null
  
)

export default component.exports